import { DefaultLanguage } from "@/lang/lang"


const locale = (locale: string = DefaultLanguage, action: any) => {
    if (action.type === 'setLocale') {
        return action.locale
    }
    return locale
}
export default locale